import React from 'react';
import './StatsCard.css';

const StatsCard = ({ icon: Icon, title, value, change, changeType }) => {
  return (
    <div className="stats-card">
      <div className="stats-card-icon">
        <Icon size={28} />
      </div>
      <div className="stats-card-content">
        <p className="stats-card-title">{title}</p>
        <h3 className="stats-card-value">{value}</h3>
        {change && (
          <p className={`stats-card-change ${changeType}`}>
            {changeType === 'positive' ? '↑' : '↓'} {change}
          </p>
        )}
      </div>
    </div>
  );
};

export default StatsCard;